import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import get from 'lodash.get';

import { schedule as schedulePropType } from 'lib/CustomPropTypes/TVE';

import ScheduleProvider from 'components/TVE/ScheduleProvider';
import StandaloneSignIn from 'components/TVE/StandaloneSignIn';
import TypeIcon from 'components/TypeIcon';
import LoadingText from 'components/packages/Waffle/LoadingPlaceholders/LoadingText';

import Logo from '../Logo/MsnbcTVE';

class MsnbcTVE extends React.Component {
  static propTypes = {
    epgCurrent: PropTypes.shape(schedulePropType),
    epgLoading: PropTypes.bool,
    headline: PropTypes.string,
    url: PropTypes.string.isRequired,
  };

  static defaultProps = {
    epgCurrent: {},
    epgLoading: false,
    headline: null,
  };

  getTease = () => {
    const {
      epgCurrent,
    } = this.props;

    // Default to current schedule
    if (epgCurrent && epgCurrent.thumbnail) {
      return (
        <video width="142px" height="80px" autoPlay loop muted playsInline>
          <source src={epgCurrent.thumbnail} type="video/mp4" />
        </video>
      );
    }

    return null;
  }

  getHeadline = () => {
    const {
      epgCurrent,
      epgLoading,
      headline,
    } = this.props;

    // Manual override
    if (headline) {
      return headline;
    }

    if (epgLoading) {
      return <LoadingText />;
    }

    // Default to current schedule
    const current = get(epgCurrent, 'program.title', null);
    return (
      <React.Fragment>
        {i18next.t('Watch Live')}
        :&nbsp;
        {current}
      </React.Fragment>
    );
  }

  render() {
    const { url } = this.props;

    return (
      <React.Fragment>
        <button
          className="mini-player__button"
          onClick={() => {
            window.location = url;
          }}
          type="button"
        >
          <div className="mini-player__tease">
            {this.getTease()}
            <TypeIcon className="mini-player__typeicon" type="video" />
          </div>
          <div className="mini-player__content">
            <Logo />
            <h1 className="mini-player__headline">
              {this.getHeadline()}
            </h1>
          </div>
        </button>

        <div className="mini-player__sign-in">
          <StandaloneSignIn
            className="mini-player__sign-in-button"
            redirectUrl={url}
          >
            <span className="icon icon-lock" />
            <span className="mini-player__sign-in-button-text">
              {i18next.t('Sign In')}
            </span>
          </StandaloneSignIn>
        </div>
      </React.Fragment>
    );
  }
}

export default ScheduleProvider(MsnbcTVE);
